module.exports = __webpack_public_path__ + "img/brief_picture_01.c757485f.png";